<template>
  <div class="w-96 bg-gray-900 flex-none relative overflow-y-auto">
    <div class="w-full absolute top-0">
      <div
        v-if="roundData"
        class="flex items-stretch justify-center flex-none"
      >
        <div
          class="w-96 h-full bg-gray-950 flex flex-col items-stretch border-l border-gray-800"
        >
          <div class="justify-start p-4 bg-gray-950 flex items-center gap-3 border-b border-gray-800">
            <img class="w-8 h-8" src="../../assets/icons/ctbadge.png">
            <h1 class="text-white w-full text-lg font-bold flex-1">
              {{ ctPlayers[0]?.team || "CT" }}
            </h1>
            <h2 class="text-text-ct text-lg font-bold">
              {{ roundData.cTScore }}
            </h2>
          </div>

          <div class="w-full h-full flex items-center flex-col even:bg-gray-900 relative" v-for="player in sortedCTPlayers" :key="player.steamID">
            <div class="flex w-full">
              <div
                class="flex flex-col w-full px-4 py-3 gap-1.5"
                :class="[player.hp === 0 ? 'bg-gray-900' : '']">
                <div class="flex items-center gap-1">
                  <p v-if="player.armor" class="text-text-primary text-sm">{{ player.armor }}</p>
                  <span v-if="player.armor" class="text-gray-600 text-sm">•</span>
                  <p
                    class="text-sm flex-1 cursor-pointer"
                    :class="[player.hp === 0 ? 'text-text-disabled' : 'text-text-primary']"
                    @click="$emit('select', player.steamID)">
                    {{ player.playerName }}</p>

                  <img
                    v-if="getPrimary(player)"
                    class="h-4"
                    :src="`/img/icons/${getPrimary(player).weaponName}.png`"
                  />
                </div>
                <div class="flex items-center gap-1">
                  <img
                    v-if="player.hasHelmet"
                    class="h-4 brightness-75"
                    src="../../assets/icons/headarmor.svg"
                  />
                  <img
                    v-else-if="player.armor > 0"
                    class="h-4 brightness-75"
                    src="../../assets/icons/armor.svg"
                  />
                  <img
                    v-if="player.hasDefuse"
                    class="h-3 brightness-75"
                    src="../../assets/icons/defuser.svg"
                  />
                  <p
                    class="text-sm flex-1"
                    :class="[player.hp === 0 ? 'text-text-disabled' : 'text-text-secondary']">
                    ${{ player.cash }}</p>
                  <div v-for="item in getSortedInventory(player.inventory)" :key="item.weaponName">
                    <img
                      v-if="
                        item.weaponClass === 'Grenade'
                          && getPrimary(player).weaponName !== item.weaponName
                      "
                      class="h-4 brightness-75"
                      :src="`/img/icons/${item.weaponName}.png`"
                    />
                  </div>
                </div>
              </div>
              <div v-if="player.hp === 0" class="absolute right-3 h-full flex items-center justify-center">
                <img class="h-4" src="../../assets/icons/skull.svg" />
              </div>
            </div>

            <div class="w-full bg-[#23354e] absolute bottom-0 h-0.5">
              <div
                class="h-full bg-text-ct"
                :style="{
                  width: `${player.hp}%`,
                }"
              />
            </div>
          </div>

          <!-- Spacer when no players found -->
          <div v-if="(!ctPlayers || ctPlayers.length === 0) && (!tPlayers || tPlayers.length === 0)" style="height: 350px;" />

          <div class="justify-start p-4 bg-gray-950 flex items-center gap-3 border-b border-gray-800">
            <img class="w-8 h-8" src="../../assets/icons/tbadge.png">
            <h1 class="text-white w-full text-lg font-bold flex-1">
              {{ tPlayers[0]?.team || "T" }}
            </h1>
            <h2 class="text-text-t text-lg font-bold">
              {{ roundData.tScore }}
            </h2>
          </div>

          <div class="w-full h-full flex items-center flex-col even:bg-gray-900 relative" v-for="player in sortedTPlayers" :key="player.steamID">
            <div class="flex w-full relative">
              <div
                class="flex flex-col w-full px-4 py-3 gap-1.5"
                :class="[player.hp === 0 ? 'bg-gray-900' : '']">
                <div class="flex items-center gap-1">
                  <p v-if="player.armor" class="text-text-primary text-sm">{{ player.armor }}</p>
                  <span v-if="player.armor" class="text-gray-600 text-sm">•</span>
                  <p
                    class="text-sm flex-1 cursor-pointer"
                    :class="[player.hp === 0 ? 'text-text-disabled' : 'text-text-primary']"
                    @click="$emit('select', player.steamID)">
                    {{ player.playerName }}</p>

                  <img
                    v-if="getPrimary(player)"
                    class="h-4"
                    :src="`/img/icons/${getPrimary(player).weaponName}.png`"
                  />
                </div>
                <div class="flex items-center gap-1">
                  <img
                    v-if="player.hasHelmet"
                    class="h-4 brightness-75"
                    src="../../assets/icons/headarmor.svg"
                  />
                  <img
                    v-else-if="player.armor > 0"
                    class="h-4 brightness-75"
                    src="../../assets/icons/armor.svg"
                  />
                  <img
                    v-if="player.hasDefuse"
                    class="h-3 brightness-75"
                    src="../../assets/icons/defuser.svg"
                  />
                  <p
                    class="text-sm flex-1"
                    :class="[player.hp === 0 ? 'text-text-disabled' : 'text-text-secondary']">
                    ${{ player.cash }}</p>
                  <div v-for="item in getSortedInventory(player.inventory)" :key="item.weaponName">
                    <img
                      v-if="
                        item.weaponClass === 'Grenade'
                          && getPrimary(player).weaponName !== item.weaponName
                      "
                      class="h-4 brightness-75"
                      :src="`/img/icons/${item.weaponName}.png`"
                    />
                  </div>
                </div>
              </div>
              <div v-if="player.hp === 0" class="absolute right-3 h-full flex items-center justify-center">
                <img class="h-4" src="../../assets/icons/skull.svg" />
              </div>
            </div>

            <div class="w-full bg-[#23354e] h-0.5 absolute bottom-0">
              <div
                class="h-full bg-text-t"
                :style="{
                  width: `${player.hp}%`,
                }"
              />
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="w-full h-full flex mt-10 items-center justify-center"
      >
        <svg
          class="animate-spin h-16 w-16 text-primary-600"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          />
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0
            12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135
            5.824 3 7.938l3-2.647z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  roundData: Object,
  ctPlayers: Array,
  tPlayers: Array,
  sortedCTPlayers: Array,
  sortedTPlayers: Array,
  getPrimary: Function,
  getSortedInventory: Function,
});

defineEmits(['select']);
</script>
